import values from "../values";

import { Layout } from "../components";
import { NotFound } from "../screen";
import { Navigate, Route, Routes } from "react-router-dom";

import DriverContainer from "../screen/DriverScreen/container/Common.container";
import ClientContainer from "../screen/ClientScreen/container/Common.container";
import OrderContainer from "../screen/OrderScreen/container/Common.container";
import CategoryClient from "../screen/CategoryScreen/container/Common.container";
import CompanyContainer from "../screen/CompanyScreen/container/Municipality.container";
import MunicipalityContainer from "../screen/MunicipalityScreen/container/Admin.container";
import TicketContainer from "../screen/TicketScreen/Container/Common.container";

const MunicipalityRoute = () => {
  let topMenu: any = values.topMenuItems.TOP_MENU_ROLE_Municipality;

  return (
    <Layout topMenuItems={topMenu}>
      <Routes>
        <Route path="/" element={<Navigate to={"company"} />} />
        {/* <Route path="/financial/*" element={<FinanCialScreen />} /> */}
        <Route path="/municipality/*" element={<MunicipalityContainer />} />
        <Route path="/company/*" element={<CompanyContainer />} />
        <Route path="/drivers/*" element={<DriverContainer />} />
        <Route path="/orders/*" element={<OrderContainer />} />
        <Route path="/clients/*" element={<ClientContainer />} />
        <Route path="/categories/*" element={<CategoryClient />} />
        <Route path="/ticket/*" element={<TicketContainer />} />
        {/* <Route path="/other/*" element={<OtherScreen />} /> */}
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
};

export default MunicipalityRoute;
